// src/components/HiddenBlock.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import Article from "./Article";
import { Text } from "./base/index";

const HiddenBlock = ({ block, handleAnchor }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="hidden-block">
      <Text
        tag="button" // Changed to button for better accessibility
        type="button"
        className="hidden-block-text cursor-pointer text-red-500 underline focus:outline-none focus:ring-2 focus:ring-red-500"
        onClick={toggleVisibility}
        aria-expanded={isVisible}
        aria-controls={`hidden-content-${block.id}`}
      >
        [hidden block]
      </Text>
      {isVisible && (
        <div id={`hidden-content-${block.id}`}>
          <Article content={block} handleAnchor={handleAnchor} />
        </div>
      )}
    </div>
  );
};

HiddenBlock.propTypes = {
  block: PropTypes.object.isRequired,
  handleAnchor: PropTypes.func.isRequired,
};

export default HiddenBlock;